import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { postPuzzleGuess } from '../../../../../../../features/puzzle/puzzleThunk'
import { parentMeta } from '../../../../type'
import { Id } from '../../../../../../../shared/types'
import { useAppSelector } from '../../../../../../../app/hooks'

interface TextPuzzle {
  puzzleId?: Id
  sceneId?: Id
}

type FormValues = {
  guess: string
}

const useTextPuzzle = (props: TextPuzzle) => {
  const { sceneId, puzzleId } = props
  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  const dispatch = useDispatch()

  const {
    data: guessData,
    loading: guessLoading,
    error: guessError,
  } = useAppSelector((state) => state.puzzle)

  const methods = useForm<FormValues>({
    defaultValues: {
      guess: '',
    },
  })

  const onSubmit = (data: FormValues) => {
    if (!sceneId || !puzzleId) {
      console.error('Unable to guess. Missing id:', props)
      return
    }
    const request = {
      sceneId,
      puzzleId,
      guess: data.guess,
    }
    dispatch(postPuzzleGuess(request))
  }

  return {
    guess: {
      data: guessData,
      loading: guessLoading,
      error: guessError,
    },
    register: methods.register,
    formState: methods.formState,
    errorMessage: methods.formState.errors.guess?.message,
    handleSubmit: methods.handleSubmit(onSubmit),
    debugP2,
  }
}

export default useTextPuzzle
